module.exports = __webpack_public_path__ + "img/calendar.59ae5e20.png";